import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";

const NavButton = ({ icon, label, isActive, onClick, hasBadge, badgeText }) => (
	<TouchableOpacity style={[styles.navButton, isActive && styles.activeNavButton]} onPress={onClick}>
		<Ionicons name={icon} size={20} color={isActive ? "#fff" : "#888"} />
		<Text style={[styles.navButtonText, isActive && styles.activeNavButtonText]}>{label}</Text>
		{hasBadge && badgeText && (
			<View style={styles.navBadge}>
				<Text style={styles.navBadgeText}>{badgeText}</Text>
			</View>
		)}
	</TouchableOpacity>
);

const styles = StyleSheet.create({
	navButton: {
		flexDirection: "row",
		alignItems: "center",
		gap: 8,
		paddingVertical: 8,
		paddingHorizontal: 14,
		borderRadius: 8,
		borderWidth: 1,
		borderColor: "transparent",
	},
	activeNavButton: {
		backgroundColor: "#2A2A2A",
		borderColor: "#3A3A3A",
	},
	navButtonText: {
		fontSize: 14,
		color: "#888",
		fontWeight: "500",
	},
	activeNavButtonText: {
		color: "#fff",
	},
	navBadge: {
		position: "absolute",
		top: 0,
		right: -5,
		transform: [{ rotate: "15deg" }],
		backgroundColor: "#0A84FF",
		paddingVertical: 2,
		paddingHorizontal: 6,
		borderRadius: 10,
		justifyContent: "center",
		alignItems: "center",
		borderWidth: 1,
		borderColor: "#1A1A1A",
	},
	navBadgeText: {
		color: "#fff",
		fontSize: 10,
		fontWeight: "bold",
		textTransform: "uppercase",
	},
});

export default NavButton;
